import { createApiThunk } from "./thunkWrapper";

// createQuiz
export const createQuiz = createApiThunk("quiz/create", (payload) => ({
  method: "POST",
  endPoint: "createQuiz", // points to api_endpoints.create
  data: payload,

}));

export const getQuiz = createApiThunk("quiz/getall", (payload) => ({
  method: "GET",
  endPoint: "getAllQuiz", // points to api_endpoints.create
  params: payload,

}));
export const deleteQuiz = createApiThunk("quiz/delete", (payload) => ({
  method: "POST",
  endPoint: "deleteQuiz", // points to api_endpoints.create
  params: payload,

}));
export const getQuizQuestions = createApiThunk("quiz/getallQuestions", (payload) => ({
  method: "GET",
  endPoint: "getAllQuizQuestions", // points to api_endpoints.create
  params: payload,

}));

export const createQuizQuestions = createApiThunk("quiz/createQuestions", (payload) => ({
  method: "POST",
  endPoint: "createQuizQuestions", // points to api_endpoints.create
  data: payload,

}));
export const uploadExcel = createApiThunk("quiz/uploadExcelQuestions", (payload) => ({
  method: "POST",
  endPoint: "uploadExcel", // points to api_endpoints.create
  data: payload,

}));
export const deleteQuizQuestions = createApiThunk("quiz/deleteQuizQuestion", (payload) => ({
  method: "POST",
  endPoint: "deleteQuizQuestions", // points to api_endpoints.create
  params: payload,

}));

export const getDashboardData = createApiThunk("quiz/createQuestions", (payload) => ({
  method: "GET",
  endPoint: "getDashBoardData",
}));
export const getDisableEnableButton = createApiThunk("quiz/createQuestions", (payload) => ({
  method: "GET",
  endPoint: "getDisableEnableButton",
}));
export const getAllUsers = createApiThunk("quiz/createQuestions", (payload) => ({
  method: "GET",
  endPoint: "getAllUsers",
  params:payload
}));
export const disableEnableButton = createApiThunk("quiz/createQuestions", (payload) => ({
  method: "POST",
  endPoint: "disableEnableButton",
   data: payload,
}));